import { useDispatch, useSelector } from "react-redux";
import { IState } from "../../../../redux/reducers/rootReducers";
import { Box,  Popover, Typography } from "@mui/material";
import { memo, useEffect, useState } from "react";
import { storeFiltersValue } from "../../../../redux/actions/TicketsManagement/GetTickets";
import { makeStyles } from "@mui/styles";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import ConfirmationModel from "../../../common2/ConfirmationModel";
export const LayoutShift = memo(() => {
//     console.log('SearchBox_rerendered', 'SortOption')
    const dispatch = useDispatch();
    const classes:any = useStyles();
    //Confirmation model states and handlers
    const [isModalOpen,setIsModalOpen] = useState(false);
    const [pendingLayout,setPendingLayout] = useState<string | null>(null);
    const [modalMode,setModalMode] = useState<"LIST_SUGGESTION" | "STATUS_CLEAR_FILTER" | null>(null);
    const LayoutType: any = useSelector(
        (state: IState) => state?.LayoutTicketManagementReducer?.layout
    );
    //All the selected filters values from the store
    const selectedStatuses:any = useSelector(
        (state:IState)=> state?.filtersTicketManagementReducer?.statuses
    );
    const TicketStatus:any = useSelector(
        (state:IState)=> state?.TicketsReducer?.allResponses?.ticketStatus
    );
    // Storing the closed status to remove filters while switching to Status view From List/
    const closedStatusIds = (TicketStatus || [])
        .filter((s:any) => s?.name?.toLowerCase() === "closed")
        .map((s:any) => s.id);
//     console.log('closedStatusIds', closedStatusIds)

    //Checks if selected filters is including closed status
    const isClosedSelected = closedStatusIds.some((id:any) =>
        selectedStatuses?.includes(id)
    );
//     console.log('isClosedSelected',isClosedSelected)
    const [viewVal,setViewVal] = useState(LayoutType ? LayoutType : "Status")
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
    useEffect(()=>{
        dispatch(storeFiltersValue(viewVal, 'TCKT_LAYOUT_VALUE'));
    },[viewVal])
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    // Handler when user confirms in the modal
    const handleConfirm = () => {
        if(modalMode === "LIST_SUGGESTION"){
            dispatch(storeFiltersValue("List",'TCKT_LAYOUT_VALUE'));
            setViewVal("List");
        }
        if(modalMode === "STATUS_CLEAR_FILTER"){
            // Remove Closed Filter
            const updatedStatuses = selectedStatuses.filter(
                (id:any)=> !closedStatusIds.includes(id)
            );
            dispatch(storeFiltersValue(updatedStatuses,"TCKT_STATUS_VALUE"))
            dispatch(storeFiltersValue("Status",'TCKT_LAYOUT_VALUE'))
            setViewVal("Status")
        }
        setPendingLayout(null)
        setModalMode(null)
        setIsModalOpen(false)
    }

    const handleCancel = () => {
        setPendingLayout(null);
        setModalMode(null);
        setIsModalOpen(false);
    }

    const handleClose = () => {
        setAnchorEl(null);
    };
    const clickHandler = ( value: string) => {
        // CASE 1
        // User is in List/Priority with Closed filter and tries to go to Status
        if(value === "Status" && isClosedSelected && LayoutType !== "Status"){
            setPendingLayout("Status");
            setModalMode("STATUS_CLEAR_FILTER");
            setIsModalOpen(true);
            handleClose();
            return;
        }

        // CASE 2
        // User is in Status and Closed filter applied -> suggest List view
        if(value === "Status" && isClosedSelected && LayoutType === "Status"){
            setPendingLayout("List");
            setModalMode("LIST_SUGGESTION");
            setIsModalOpen(true);
            handleClose();
            return;
        }
        //CASE 3
        // User is in List and No Filter applied and tries to go to Status, we can directly switch without confirmation as closed status is not selected.
        if(value === "Status" && !isClosedSelected){
            dispatch(storeFiltersValue("Status",'TCKT_LAYOUT_VALUE'));
            handleClose();
            return;
        }
        //dispatch(storeFiltersValue(value, 'TCKT_LAYOUT_VALUE'));
        setViewVal(value)
        handleClose();
    }
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    return (
        <>
            <Typography aria-describedby={id} onClick={handleClick} className={`${classes.filterItem} toggler`}>
                <MenuOutlinedIcon /> {LayoutType}  <ArrowDropDownIcon />
            </Typography>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <Box sx={{ p: 1 }}>
                    <Typography onClick={() => { clickHandler("Status") }} className={`${classes.filterItem} ${LayoutType === "Status" ? "active" : "" }`}>
                        <span>Status</span>
                    </Typography>
                    <Typography onClick={() => { clickHandler("Priority") }} className={`${classes.filterItem} ${LayoutType === "Priority" ? "active" : "" }`}>
                        <span>Priority</span>
                    </Typography>
                    <Typography onClick={() => { clickHandler("List") }} className={`${classes.filterItem} ${LayoutType === "List" ? "active" : "" }`}>
                        <span>List View</span>
                    </Typography>
                </Box>
            </Popover>
            <ConfirmationModel
                open={isModalOpen}
                labelTop={modalMode === "LIST_SUGGESTION" ? "Switch to List View?" : "Switch to Status View?"}
                labelBottom={modalMode === "LIST_SUGGESTION" ? "It provides a detailed overview of tickets." : "Your closed ticket filter will be cleared."}
                onSubmitHandler={handleConfirm}
                handleClose={handleCancel}
                btn="Switch"
            />
        </>
    )
})
const useStyles:any = makeStyles(() => ({
    filterTitle:{
        fontSize:"13px",
        borderBottom:"1px solid #ddd"
    },
    filterItem:{
        fontSize:"11px",
        padding: "2px 5px",
        display: "flex",
        alignItems: "center",
        justifyContent:"space-between",
        cursor:"pointer",
        gap: "2px",
        "&.toggler":{
            cursor:"pointer",
            "&.active":{
                color:"#0b0b89 !important",
                background:"#fff0 !important"
            },
            "&:hover":{
                color:"#0b0b89 !important",
                background:"#fff0 !important"
            },
        },
        "& svg":{
            width: "18px",
            height: "18px",
            color: "#777",
            cursor:"pointer",
            "&:hover":{
                color:"#007bff"
            },
            "&.active":{
                color:"#007bff"
            },
        },
        "&:hover":{
            background:"#2f80ed14"
        },
        "&.active":{
            background:"#2f80ed14"
        },
    },
    checkedIcon:{
        color:"#007bff !important"
    }
}))
export default LayoutShift;